import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITransition } from "./transition.interfaces";

const initialState: ITransition = {
  inTransition: false,
};

export const transitionSlice = createSlice({
  name: "transition",
  initialState,
  reducers: {
    setInTransition: (state, action: PayloadAction<boolean>) => {
      state.inTransition = action.payload;
    },
  },
});

export const { setInTransition } = transitionSlice.actions;
